<template >
  <div>
    <!-- 初次进入官网时的视频 -->
    <!-- <div  id="my" v-if="isFirst">
      <video id="myVideo" src="../../../assets/vedio/animation_home.mp4" style="height:100%;width:100%;object-fit:cover;" autoplay muted fullscreen controlslist="nodownload noremoteplayback" width="100%" height="100%"></video>
    </div> -->
    <div class="mainContent">
      <Header id="top" style="height: 8vh;"></Header>
      <!-- part1应该是轮播图 -->
      <div class="swiper-demo">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide img0 showImg">
                <div class="title">
                    <div>耳鸣康复治疗仪</div>
                </div>
                <div class="deviceImg"></div>
                <div class="regCode">
                  <el-row>
                    <el-col style="text-align: right" :span="12">医疗器械注册证编号：</el-col>
                    <el-col style="text-align: left"  :span="12">苏械注准20222191488</el-col>
                  </el-row>
                  <el-row>
                    <el-col style="text-align: right"  :span="12">医疗器械生产许可证编号：</el-col>
                    <el-col style="text-align: left"  :span="12">苏药监械生产许20220242号</el-col>
                  </el-row>
                </div>
            </div>
            <div class="swiper-slide img1 showImg">
              <div class="title">
                <div>听力计</div>
              </div>
            </div>
            <div class="swiper-slide img2 showImg">
              <div class="title">
                <div>耳声发射检测仪</div>
              </div>
            </div>
            <div class="swiper-slide img3 showImg">
              <div class="title">
                <div>真耳分析仪</div>
              </div>
            </div>
            <div class="swiper-slide img4 showImg">
              <div class="title">
                <div>耳鸣康复治疗仪</div>
              </div>
            </div>
            <div class="swiper-slide img5 showImg">
              <div class="title">
                <div>耳鸣康复治疗仪+耳鸣信息分析管理软件</div>
              </div>
            </div>
            <div class="swiper-slide img6 showImg">
              <div class="title">
                <div>耳鸣检测治疗仪</div>
              </div>
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          <!-- 如果需要滚动条 -->
          <div class="swiper-scroll-scrollbar"></div>
        </div>
      </div>
  
      <!-- <div class="price">官方价￥<span class="number">{{ price }}</span></div>
      <div class="bugBtn">
        <van-button @click="goPay" round color="#733d9a">立即购买</van-button>
      </div> -->
      <!-- 其余part应该是长度可变的v-for -->
      <div class="part2">
        <div class="title2">产品介绍</div>
        <div class="part2ContentBox">
          <div class="part2Font">

            <div class="part2Font1">清耳话声“耳鸣康复治疗仪”获得</div>
            <div class="part2Font3">2022年日内瓦国际发明金奖 <br> 2020年全国发明金奖</div>
            <div class="part2Font3">国家二类医疗器械注册证书和生产许可证书</div>
            <div class="part2Font3">发明专利和软件著作权20余项</div> <div  class="part2Font3">
            通过中国电子学会科技成果鉴定
          </div>
          </div>
          <div class="part2Img">
            <img width="100%" height="100%" class="part2Img1" src="@/assets/image/z8775.png"></img>
          </div>
        </div>
      </div>
      <div class="part3">
        <div class="title2">治疗原理</div>
        <div class="part3Content">
          <div class="part3ContentBox">
            <div class="part3Img1">
              <img src="@/assets/image/z637.png"></img>
            </div>
            <div class="part3Img2">
              <img src="@/assets/image/z10661.png"></img>
            </div>
            <div class="part3Font">
              将音乐中以耳鸣频率为中心的一段频率移除，从而制成有切迹的音乐。目的是激活耳鸣频率附近的听皮层神经活动，抑制切迹范围内频率对应的听皮层神经活动，产生侧抑制效果，从而促进听皮层特定区域的重塑，减弱耳鸣活动及其相关感知。
            </div>
          </div>
          <div class="part3ContentBox">
            <div class="part3Img1">
              <img src="@/assets/image/z653.png"></img>
            </div>
            <div class="part3Img2">
              <img src="@/assets/image/z10671.png"></img>
            </div>
            <div class="part3Font">
              通过外界给予与损伤部分毛细胞相对应的宽带或窄带噪声为掩蔽声，抑制耳蜗或蜗神经的自发性兴奋增强的活动，降低异常自发放电活动，从而达到减轻或消除耳鸣的目的。
            </div>
          </div>
        </div>
      </div>
      <div class="part4">
        <div class="title2">产品特点</div>
        <div class="part4ContextBox">
          <div class="part4ContextBox1">
            <div style="margin: auto">
              <img src="@/assets/image/z10788.png"></img>
            </div>
            <div class="part4Font">
              <div>
                全球首创集“耳鸣精准检测✚个性化智能音乐治疗”于一体的便携式医疗器械，您的专属耳鸣治疗仪。
          </div>
            </div>
          </div>


          <div class="part4ContextBox1">
            <div  style="margin: auto">
              <img src="@/assets/image/z11156@2x (1).png"></img>
            </div>
            <div class="part4Font">
              技术源于清华，根据耳鸣症状，对症用“乐”，个性化、精准定量的音乐治疗方案，安全、有效解决耳鸣痛苦。
            </div>
          </div>
        </div>
        <div class="part4ContextBox">


          <div class="part4ContextBox1" style="width: 100%">
            <div  style="margin: auto">
              <img src="@/assets/image/z10769.png"></img>
            </div>
            <div class="part4Font"> <div>
              高性能设备加创新性算法，选用大动态范围、高频响硬件+经过校准的专业定制声学耳机，解决高频耳鸣无法治愈的国际难题，
              为耳鸣患者尤其是高频耳鸣患者的康复带来福音。
              中国电子学会科技成果鉴定：“原创性地提出针对高频耳鸣的对数能量均衡技术，实现对高频耳鸣的有效治疗”。</div>
            </div>
          </div>

        </div>
        <div class="part4ContextBox">
          <div class="part4ContextBox1">
            <div  style="margin: auto">
              <img src="@/assets/image/z10774.png"></img>
            </div>
            <div class="part4Font">
              小巧、便携、功能强大，避免多次往返医院。
            </div>
          </div>
          <div class="part4ContextBox1">
          <div  style="margin: auto">
          <img src="@/assets/image/z10789.png"></img>
          </div>
          <div class="part4Font">
            首创基于中枢机理的全自然音乐背景治疗耳鸣，轻松悦耳又舒适。
          </div>
          </div>
        </div>
      </div>
      <ScrollTop></ScrollTop>
      <Footer ></Footer>
    </div>
  </div>
</template>

<script>
import Header from "./compoents/Header.vue";
import Footer from "./compoents/Footer.vue";
import ScrollTop from "./compoents/ScrollTop.vue";
import ElImage from "../../../../node_modules/element-ui/packages/image/src/main.vue";
import SuperGif from "../../libgif.js";
import ElCol from "element-ui/packages/col/src/col";
import { reqGetGoodsList } from '@/api/goods';
// 引入轮播图组件及其样式
import Swiper from 'swiper';
import "swiper/css/swiper.min.css";
// 引入轮播图下方指示器
import { Pagination } from "swiper";
export default {
  name: "Home",
  components: {
    ElCol,
    ElImage,
    Header, 
    Footer,
    ScrollTop
  },
  data() {
    return {
      modules: [Pagination],
      activeName: "1",
      isFirst:1,          // 是否第一次进入官网，用于控制动画的显示
      topOffect: 0,
      flag: [],
      deviceRow:{},
      price: '',
      divTop: ''
    };
  },
  created() {
    try{
      this.flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (this.flag) {
        this.$router.push({
          name: 'phoneHome', 
          query: {
            doctor_id: this.$route.query.doctor_id,
            scene: this.$route.query.scene
          }
        })
      } else {
        this.doctor_id = this.$route.query.doctor_id;
        this.scene = this.$route.query.scene;
        // this._getActivity();
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var curDate = date.getDate();
        var nowDate = year +'-' +month+'-'+curDate;
        if( this.$store.state.isFirst != nowDate){
            this.isFirst=1;
            this.timer = setInterval(() => {
                this.isFirst=0;
                clearInterval(this.timer) // 清除定时器
                this.timer = null
                this.$store.state.isFirst = nowDate;
            }, 2750)    // 11000
        }else{
            this.isFirst=0;
        }
      }
    }catch(err){
      console.log(err.message);
    }
    this.getPrice()
  },
  mounted(){
    // document.getElementById("myVideo").playbackRate="4";
    // 获取耳鸣仪的价钱和编号

    // 初始化轮播图
    new Swiper(".swiper-container", {
      // direction: "vertical",
      loop: true,
      autoplay: true,

      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // 如果需要滚动条
      scrollbar: {
        el: ".swiper-scrollbar"
      },

      on: {
        slideChangeTransitionStart: function(){
          for(let i = 1; i <= 8; i++){
            if(this.activeIndex == i){
              document.getElementsByClassName('title')[i].classList.add('enter-x-left');
            }else{
              document.getElementsByClassName('title')[i].classList.remove('enter-x-left');
            }
          }
        }
      }
    });
  },
  methods: {
    showDiv(activeIndex){
      // 为当前显示的添加样式，其余的清除样式
      document.getElementsByClassName('title')[activeIndex-1].classList.add('enter-x-left');
      console.log('为', activeIndex-1, '添加样式')
      if(activeIndex == 1){
        document.getElementsByClassName('title')[6].classList.remove('enter-x-left');
        console.log('为6清除样式')
      }else{
        document.getElementsByClassName('title')[activeIndex-2].classList.remove('enter-x-left');
        console.log('为', activeIndex-2, '清除样式')
      }
      
    },
    InitSuperGif() {
      // 通过异步函数，获取gif文件
      var sup1 = new SuperGif({
        gif: document.getElementById("example1"),
        progressbar_foreground_color: "#9254de",
        progressbar_background_color: "#ebeef5",
        progressbar_height: 10,
      });
      sup1.load();
      this.sup1 = sup1;
    },
    goTop(){
      document.getElementById('top').scrollIntoView({ behavior: "smooth" });
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    goPay() {
      if(!this.$store.state.customer.customerInfo.mobile){
        this.$router.push({ name: 'login' , params:{'scene':1} });
      }else{
        this.$router.push({
          name: 'orderInfo', 
          query: { device_id: 5 }  
        })
      }
    },
    async _getActivity() {
      try{
        let param = {
          doctor_id: this.doctor_id || '',
          device_id: 1,
          scene: this.scene || ''
        };
        let res = await getActivity(param);
        if (res.status == 0) {
          this.deviceRow = res.data.deviceRow;
          this.redirect_uri = res.data.redirect_uri;
        }
      }catch(err){
        console.log(err);
      } 
    },
    // 获取价格信息
    async getPrice(){
      let params ={
        pageCurrent: 1,
        pageSize: 1
      };
      let res = await reqGetGoodsList(params)
      if (res.code == 200) {
        this.price = res.data[0].price
      } else {
        this.$message.error(res.message);
      }  
    }
  }
};
</script>

<style scoped>
@import url(./style/common.css);
.mainContent {
  margin: 0;
  padding: 0;
}

.img0 {
  background: url(../../../assets/image/websybj.png);
}

.img1 {
  background: url(./image/audiometer.png);
}
 
.img2 {
  background: url(./image/earHearing.png);
}
.img3 {
  background: url(./image/realear.png);
}
.img4 {
  background: url(./image/therapeutic.png);
}
.img5 {
  background: url(./image/new3.png);
}
.img6 {
  background: url(./image/new4.jpg);
}

.showImg {
  background-position: center; /*将图片居中显示*/
  min-height: 92vh; /*确保至少是视口高度*/
  background-size: 100% 100%; /*确保图片覆盖整个元素*/
  background-repeat: no-repeat;
}


.swiper-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.part {
  width: 100%;
  /* height: 924px; */
  height: 100%;
  /* 图片可以保有其原 有的尺寸，或者拉伸到新的尺寸，或者在保持其原有比例的同时缩放到元素的可用空间的尺寸。 */
  /* background-size: cover; */
  background-size: 100% 100%;
  position: relative;
}
.part1 {
  width: 100%;
  /* height: 924px; */
  height: 100%;
  background: url(../../../assets/image/websybj.png) ;
  /* 图片可以保有其原 有的尺寸，或者拉伸到新的尺寸，或者在保持其原有比例的同时缩放到元素的可用空间的尺寸。 */
  /* background-size: cover; */
  background-size: 100% 100%;
  position: relative;
}

.animation2 {
  width: 100%;
    height: 100%;
  position : absolute;
  animation: move 12s  ;
}


.logo {
  align-items: center;
  height: 45px;
  margin-right: 10px;
}

.logoBox {
  display: flex;
  line-height: 65px;
  align-items: center;
  font-size: 18px;
}
.title {
  width: 100%;
  /* margin: auto; */
  text-align: center;
  margin-top: 40px;
  font-size: 40px;

  font-weight: 400;
  line-height: 44px;
  color: #000000;
}
.enter-x-left {
  
  z-index: 9;
  opacity: 0;
  animation: enter-x-left 0.4s ease-in-out 0.3s;
  animation-fill-mode: forwards;
  transform: translateX(-50px);

}
@keyframes enter-x-left {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.title>.desc {
  font-size: 40px;

  font-weight: 400;
  line-height: 44px;
  color: #000000;
}

.title>.price {
  margin-top: 15px;
  font-size: 22px;

  font-weight: 400;
  line-height: 30px;
  color: #803288;
}

.title>.price>.number {
  font-size: 40px;

  line-height: 64px;
  color: #803288;
}

.title>.bugBtn {
  margin-top: 22px;
}

.deviceImg {
  width: 558px;
  height: 511px;
  background: url("../../../assets/image/z8772.png") no-repeat;
  margin: auto;
}

.regCode {
  font-size: 16px;

  font-weight: 300;
  line-height: 38px;
  text-align: center;
}

.part2 {
  width: 100%;
  height: 900px;
  background: url(../../../assets/image/webhjbj.png);
  /* 图片可以保有其原有的尺寸，或者拉伸到新的尺寸，或者在保持其原有比例的同时缩放到元素的可用空间的尺寸。 */
  background-size: cover;
  position: relative;
}

.title2 {
  text-align: center;
  padding-top: 50px;
  height: 51px;
  font-size: 40px;

  font-weight: 300;
  line-height: 85px;
}

.part2ContentBox {
  display: flex;
  width: 73%;
  /* width: 100%; */
  margin: auto;
  justify-content: space-between;
  margin-top: 60px;
}
.part2Font {
  margin-top: 92px;
}

.part2Font1 {
  font-size: 28px;

  font-weight: bold;
  line-height: 56px;
  margin-bottom: 10px;
}

.part2Font2 {
  font-size: 22px;

  font-weight: 540;
  line-height: 38px;
}

.part2Font3 {
  font-size: 22px;

  font-weight: 300;
  line-height: 38px;
}

.part3 {
  width: 100%;
  height: 1000px;
  background: url(../../../assets/image/webzlylbj.png);
  /* 图片可以保有其原有的尺寸，或者拉伸到新的尺寸，或者在保持其原有比例的同时缩放到元素的可用空间的尺寸。 */
  background-size: cover;
}

.part3Content {
  width: 70%;
  /* height: 100%; */
  height: 774px;
  margin: auto;
  margin-top: 44px;
  display: flex;
  justify-content: space-between;
  /* flex-flow: row wrap; */
}

.part3ContentBox {
  border-radius: 30px;
  border: 1px #efedf8 solid;
  background-color: rgba(232, 229, 246, 0.6);
  width: 592px;
  height: 774px;
  margin: 0 10px;
  position: relative;
}

.part3Img1 {
  margin-top: 60px;
  text-align: center;
}

.part3Img2 {
  margin-top: 100px;
  text-align: center;
}

.part3Font {
  position: absolute;
  top:65%;
  /* bottom: 40px; */
  left: 11%;
  width: 80%;
  font-size: 20px;

  font-weight: 300;
  line-height: 35px;
  /* margin-top: 20px; */
}

.part4 {
  height: 1200px;
  background: url(../../../assets/image/webcptdbj.png);
  /* 图片可以保有其原有的尺寸，或者拉伸到新的尺寸，或者在保持其原有比例的同时缩放到元素的可用空间的尺寸。 */
  background-size: cover;
}

.part4ContextBox {

  width: 70%;
  margin: auto;
  margin-top: 44px;
  display: flex;
  justify-content: space-between;
}

.part4ContextBox1 {
  width: 594px;
  height: 295px;
  border-radius: 30px;
  background-color: rgba(253, 253, 254, 0.8);
  display: flex;
  justify-content: space-between;
  padding: 2%;
  margin: 0 10px;
  box-sizing: border-box;
}

.part4Font {
  font-size: 20px;

  font-weight: 300;
  display: flex;
  align-items: center;
  padding-left: 20px;
}


::v-deep .bugBtn > .van-button {
  /*width: 113px;*/
  /*height: 65px;*/
  /*text-*/
  border-radius: 32px;
  font-size: 20px;
}



.bootom_right {
  position: fixed;
  display: flex;
  flex-direction: column;
  right: 16px;
  bottom: 90px;
  z-index: 10;
  padding: 3px 3px 0 3px;
}


.bootom_right_top {
  position: fixed;
  display: flex;
  flex-direction: column;
  right: 28px;
  bottom: 40px;
  z-index: 10;
}


</style>
